module.exports = __webpack_public_path__ + "static/media/Mockup2.6d37835b.jpg";